/**
 * Kshetra Veda - Framer-Style Word Scroll Illumination & Stagger Reveal
 * Inspired by Framer Scroll-reveal / Apple Text Illumination
 */
(() => {
  if (window.KshetraFramerRevealInitialized) return;
  window.KshetraFramerRevealInitialized = true;

  function loadGSAP(callback) {
    if (window.gsap && window.ScrollTrigger) {
      if (callback) callback();
      return;
    }

    const script1 = document.createElement('script');
    script1.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    script1.onload = () => {
      const script2 = document.createElement('script');
      script2.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
      script2.onload = () => {
        window.gsap.registerPlugin(window.ScrollTrigger);
        if (callback) callback();
      };
      document.head.appendChild(script2);
    };
    document.head.appendChild(script1);
  }

  function initWordScrollReveal() {
    if (!window.gsap || !window.ScrollTrigger) return;

    // Target elements across Our Story, Shop Page, Lab Reports & Homepage
    const textSelectors = [
      '.kv-philosophy-quote',
      '.kv-story-mission-quote',
      '.kv-story-closing-quote',
      '.kv-story-heading',
      '.kv-story-body p',
      '.kv-shop-cta h2',
      '.kv-shop-cta p',
      '.kv-lab-subtitle',
      '.quote__text',
      '.kshetra-philosophy-quote',
      '.kshetra-philosophy-heading',
      '.kshetra-philosophy-text',
      '.kv-testimonials-heading',
      '.section-header__title',
      '.section-heading',
      '[data-scroll-reveal="words"]'
    ];

    textSelectors.forEach((sel) => {
      const elements = document.querySelectorAll(sel);
      elements.forEach((el) => {
        if (el.closest('.luxury-quote-section') || el.closest('.kv-shop-hero')) return;
        if (el.dataset.framerRevealed) return;
        el.dataset.framerRevealed = 'true';

        const rawHTML = el.innerHTML.trim();
        if (!rawHTML || rawHTML.length < 5) return;

        // Split HTML content while preserving <br> tags
        const parts = rawHTML.split(/(<br\s*\/?>|\n)/gi);

        el.innerHTML = parts
          .map((part) => {
            if (/^<br\s*\/?>$/i.test(part) || part === '\n') return part;

            // Strip any nested tags if plain text
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = part;
            const textContent = tempDiv.textContent.trim();
            if (!textContent) return '';

            const words = textContent.split(/\s+/).filter(Boolean);
            return words
              .map(
                (word) =>
                  `<span class="kv-reveal-word" style="display:inline-block; opacity: 0.18; transform: translateY(6px); margin-right: 0.24em; will-change: opacity, transform;">${word}</span>`
              )
              .join(' ');
          })
          .join('');

        const spanWords = el.querySelectorAll('.kv-reveal-word');
        if (!spanWords.length) return;

        // GSAP ScrollTrigger word illumination
        window.gsap.to(spanWords, {
          opacity: 1,
          y: 0,
          stagger: 0.05,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            end: 'bottom 45%',
            scrub: 0.8
          }
        });
      });
    });

    // Stagger fade-in for cards, mission items, and badges
    const staggerItems = document.querySelectorAll(
      '.kv-story-mission-item, .kv-story-value-card, .kv-lab-card, .kv-shop-card, .kv-lab-trust-item, .kv-shop-cta a'
    );

    staggerItems.forEach((item) => {
      if (item.dataset.staggerRevealed) return;
      item.dataset.staggerRevealed = 'true';

      window.gsap.fromTo(
        item,
        { opacity: 0.25, y: 28 },
        {
          opacity: 1,
          y: 0,
          duration: 0.75,
          ease: 'power3.out',
          onComplete: () => {
            window.gsap.set(item, { clearProps: 'transform' });
          },
          scrollTrigger: {
            trigger: item,
            start: 'top 88%',
            toggleActions: 'play none none none'
          }
        }
      );
    });
  }

  // Inject helper style
  const style = document.createElement('style');
  style.textContent = `
    .kv-reveal-word {
      display: inline-block;
      will-change: opacity, transform;
    }
  `;
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', () => {
    loadGSAP(() => {
      initWordScrollReveal();
      setTimeout(() => {
        initWordScrollReveal();
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      }, 300);
    });
  });

  if (document.readyState !== 'loading') {
    loadGSAP(() => {
      initWordScrollReveal();
      setTimeout(() => {
        initWordScrollReveal();
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      }, 300);
    });
  }
})();
